import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../@bizkeytech";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";

/**@inheritDoc*/
export class OrganizationGroupController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Lists the organization groups that are available.
     *
     * @param abortController   The abort controller that will be used to cancel the request.
     */
    public async list(abortController?: AbortController): models.ListOrganizationGroupResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.organizationGroup.list,
            signal: abortController?.signal,
        });
    }

    /**
     * Creates a new organization Group.
     *
     * @param request               The request to create a new organization group.
     * @param abortController       The abort controller that will be used to cancel the request.
     */
    public async create(request: models.CreateOrganizationGroupRequest, abortController?: AbortController): models.CreateOrganizationGroupResponse {
        return this.executor?.execute({
            method: ApiMethods.post,
            url: ApiEndpoints.organizationGroup.create,
            signal: abortController?.signal,
            data: request,
        });
    }

    /**
     * Updates an organization group.
     *
     * @param request               The request to update an organization group.
     * @param abortController       The abort controller that will be used to cancel the request.
     */
    public async update(request: models.UpdateOrganizationGroupRequest, abortController?: AbortController): models.UpdateOrganizationGroupResponse {
        return this.executor?.execute({
            method: ApiMethods.put,
            url: ApiEndpoints.organizationGroup.update,
            signal: abortController?.signal,
            data: request,
        });
    }

    /**
     * Deletes an organization group.
     *
     * @param request               The request to delete an organization group.
     * @param abortController       The abort controller that will be used to cancel the request.
     */
    public async delete(request: models.DeleteOrganizationGroupRequest, abortController?: AbortController): models.DeleteOrganizationGroupResponse {
        return this.executor?.execute({
            method: ApiMethods.delete,
            url: ApiEndpoints.organizationGroup.delete,
            signal: abortController?.signal,
            data: request,
        });
    }
}


export * from './index.types';
export default OrganizationGroupController;